module.exports = __webpack_public_path__ + "static/img/red_envelope_logo.5cd494f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/red_envelope_logo.png
// module id = cF5y
// module chunks = 1